import { create } from 'zustand'
import { createJSONStorage, persist, PersistStorage, StateStorage } from 'zustand/middleware'

interface State {
  storyCardTooltipFirstVisibleIdList: number[]
}

interface Action {
  addStoryCardTooltipFirstVisibleId: (id: number) => void
}

const isClient = typeof window !== 'undefined'

const noopStorage: StateStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
}

export const storyCardTooltipStore = create<State & Action>()(
  persist(
    (set, get) => ({
      storyCardTooltipFirstVisibleIdList: [],
      addStoryCardTooltipFirstVisibleId: (id: number) => {
        const prev = get().storyCardTooltipFirstVisibleIdList
        if (!prev.includes(id)) {
          set({ storyCardTooltipFirstVisibleIdList: [...prev, id] })
        }
      },
    }),
    {
      name: 'story-card-tooltip',
      storage: isClient ? createJSONStorage(() => sessionStorage) : (noopStorage as unknown as PersistStorage<unknown>),
    },
  ),
)
